import BinaryDataHeaderSerializer from './binaryData/HeaderSerializer';
import InfoSerializer from './binaryData/InfoSerializer';
import IntsSerializer from './binaryData/IntsSerializer';
import MltSerializer from './binaryData/MltSerializer';
import RttSerializer from './binaryData/RttSerializer';
import type { SerializerRegistry } from '@visualizer/types';

const version = 'v0_0_5';

const v0_0_5: SerializerRegistry = {
    version,
    binary: {
        HeaderSerializer: new (BinaryDataHeaderSerializer as any)(version),
        RttSerializer: new (RttSerializer as any)(version),
        MltSerializer: new (MltSerializer as any)(version),
        InfoSerializer: new (InfoSerializer as any)(version),
        IntsSerializer: new (IntsSerializer as any)(version),
    },
};

export default v0_0_5;
